import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { EventsListComponent } from './events-list.component';
import { EventsDetailComponent } from './events-detail.component';

import { AuthGuardService } from '../services/auth-guard.service';

import { UserResolverService } from '../services/user-resolver.service';
import { EventResolverService } from '../services/event-resolver.service';

const eventsRoutes: Routes = [
  {
    path: 'companies/:user_id/events',
    component: EventsListComponent,
    resolve: { user$: UserResolverService },
    canActivate: [AuthGuardService]
  },
  {
    path: 'companies/:user_id/events/:event_id',
    component: EventsDetailComponent,
    resolve: { user$: UserResolverService, event$: EventResolverService },
    canActivate: [AuthGuardService],
    loadChildren: './dashboard/dashboard.module#DashboardModule'
  },
  {
    path: 'companies/:user_id/events/:event_id/participants',
    component: EventsDetailComponent,
    resolve: { user$: UserResolverService, event$: EventResolverService },
    canActivate: [AuthGuardService],
    loadChildren: './participants/participants.module#ParticipantsModule'
  },
  {
    path: 'companies/:user_id/events/:event_id/notifications',
    component: EventsDetailComponent,
    resolve: { user$: UserResolverService, event$: EventResolverService },
    canActivate: [AuthGuardService],
    loadChildren: './notifications/notifications.module#NotificationsModule'
  },
  {
    path: 'companies/:user_id/events/:event_id/info',
    component: EventsDetailComponent,
    resolve: { user$: UserResolverService, event$: EventResolverService },
    canActivate: [AuthGuardService],
    loadChildren: './info/info.module#InfoModule'
  },
  {
    path: 'companies/:user_id/events/:event_id/news-feed',
    component: EventsDetailComponent,
    resolve: { user$: UserResolverService, event$: EventResolverService },
    canActivate: [AuthGuardService],
    loadChildren: './news-feed/news-feed.module#NewsFeedModule'
  },
  {
    path: 'companies/:user_id/events/:event_id/schedule',
    component: EventsDetailComponent,
    resolve: { user$: UserResolverService, event$: EventResolverService },
    canActivate: [AuthGuardService],
    loadChildren: './schedule/schedule.module#ScheduleModule'
  },
  {
    path: 'companies/:user_id/events/:event_id/documents',
    component: EventsDetailComponent,
    resolve: { user$: UserResolverService, event$: EventResolverService },
    canActivate: [AuthGuardService],
    loadChildren: './documents/documents.module#DocumentsModule'
  },
  {
    path: 'companies/:user_id/events/:event_id/speakers',
    component: EventsDetailComponent,
    resolve: { user$: UserResolverService, event$: EventResolverService },
    canActivate: [AuthGuardService],
    loadChildren: './speakers/speakers.module#SpeakersModule'
  },
  {
    path: 'companies/:user_id/events/:event_id/partners',
    component: EventsDetailComponent,
    resolve: { user$: UserResolverService, event$: EventResolverService },
    canActivate: [AuthGuardService],
    loadChildren: './partners/partners.module#PartnersModule'
  },
  {
    path: 'companies/:user_id/events/:event_id/feedback-form',
    component: EventsDetailComponent,
    resolve: { user$: UserResolverService, event$: EventResolverService },
    canActivate: [AuthGuardService],
    loadChildren: './feedback-questions/feedback-questions.module#FeedbackQuestionsModule'
  },
  {
    path: 'companies/:user_id/events/:event_id/analytics',
    component: EventsDetailComponent,
    resolve: { user$: UserResolverService, event$: EventResolverService },
    canActivate: [AuthGuardService],
    loadChildren: './analytics/analytics.module#AnalyticsModule'
  },
  {
    path: 'companies/:user_id/events/:event_id/faqs',
    component: EventsDetailComponent,
    resolve: { user$: UserResolverService, event$: EventResolverService },
    canActivate: [AuthGuardService],
    loadChildren: './faqs/faqs.module#FAQsModule'
  },
  {
    path: 'companies/:user_id/events/:event_id/app-design',
    component: EventsDetailComponent,
    resolve: { user$: UserResolverService, event$: EventResolverService },
    canActivate: [AuthGuardService],
    loadChildren: './app-design/app-design.module#AppDesignModule'
  },
  {
    path: 'companies/:user_id/events/:event_id/poll',
    component: EventsDetailComponent,
    resolve: { user$: UserResolverService, event$: EventResolverService },
    canActivate: [AuthGuardService],
    loadChildren: './poll/poll.module#PollModule'
  },
  {
    path: 'companies/:user_id/events/:event_id/camera-filters',
    component: EventsDetailComponent,
    resolve: { user$: UserResolverService, event$: EventResolverService },
    canActivate: [AuthGuardService],
    loadChildren: './camera-filters/camera-filters.module#CameraFiltersModule'
  },
  {
    path: 'companies/:user_id/events/:event_id/exhibitors',
    component: EventsDetailComponent,
    resolve: { user$: UserResolverService, event$: EventResolverService },
    canActivate: [AuthGuardService],
    loadChildren: './exhibitors/exhibitors.module#ExhibitorsModule'
  },
  {
    path: 'companies/:user_id/events/:event_id/sponsors',
    component: EventsDetailComponent,
    resolve: { user$: UserResolverService, event$: EventResolverService },
    canActivate: [AuthGuardService],
    loadChildren: './sponsors/sponsors.module#SponsorsModule'
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(eventsRoutes)
  ],
  exports: [
    RouterModule
  ],
  providers: [UserResolverService, EventResolverService, AuthGuardService],
})
export class EventsRoutingModule { }



// WEBPACK FOOTER //
// D:/ThinkBIT/work-projects/confe/hosting/src/app/events/events-routing.module.ts